// 聊天页翻译 - 对话、输入、专家状态等

export const zh = {
  // Chat
  emptyTitle: '把任务交给专家团队',
  emptySub: '描述你的目标，专家协作、计划审批与产物归档都在这里完成',
  emptyCardTemplate: '从模板开始',
  emptyCardTemplateDesc: '用对话模板一键起跑',
  emptyCardExpert: '新建专家',
  emptyCardExpertDesc: '定义专属协作专家',
  emptyCardChat: '直接开聊',
  emptyCardChatDesc: '输入框里写下第一句话',

  // Chat messages

  // Input & Chat
  uploadImage: '上传图片',
  attachmentImages: '图片 ×{count}',
  simple: '简单',
  complex: '复杂',
  stop: '停止',
  send: '发送',
  inputPlaceholder: '继续对话，或拖入图片…',

  // Expert Status
  clear: '清除',
  searchExpert: '搜索专家',
  analyzerExpert: '分析专家',
  // 专家显示名的唯一真相源是 lib/expertIdentity.EXPERT_TYPE_LABEL_KEY（新增系统专家在此补词条）
  imageAnalyzerExpert: '图片分析专家',
  memoryExpert: '记忆专家',
  designerExpert: '设计专家',
  architectExpert: '架构专家',
  aggregatorExpert: '汇总专家',
  commanderExpert: '编排专家',
  routerExpert: '意图识别专家',
  pending: '等待',
  running: '进行中',
  completed: '完成',

  // Orchestrator Panel

  // Expert Modal

  // Artifact Area

  // Preview Button
  preview: '预览',
  source: '源码',

  // Thinking Process
  thinking: '思考过程',
  thinkingProcess: '思考过程',
  thinkingSteps: '执行步骤',
  thinkingCompleted: '思考完成',
  thinkingInProgress: '思考中',
  /** 按专家分组的组头：该专家负责的任务数 */
  thinkingGroupTasks: '{count} 个任务',

  // Workflow Steps (Expert Drawer)

  // Thinking Steps
  thinkingSearch: '搜索',
  thinkingReading: '深度阅读',
  thinkingAnalysis: '分析思考',
  thinkingCoding: '代码生成',
  thinkingPlanning: '任务规划',
  thinkingWriting: '写作生成',
  thinkingArtifact: '生成产物',
  thinkingMemory: '记忆检索',
  thinkingExecution: '任务执行',
  thinkingDefault: '思考',
  thinkingRouting: '智能路由',
  thinkingReasoning: '深度思考',
  videoUnsupported: '您的浏览器不支持视频播放',

  // 预览相关
  videoPreview: '视频预览',
  imagePreview: '图片预览',
  messagePreview: '消息预览',
  docView: '文档视图',
  expandAll: '展开全文',
  collapseAll: '收起',

  // 其他提示
  minOneTask: '至少需要保留一个任务',
  deleteTask: '删除任务',

  // Polling (轮询恢复)
  pollingRestoring: '正在恢复任务连接...',
  pollingHitlPaused: '等待审批中...',
  pollingRefresh: '刷新',
  pollingError: '连接失败，请刷新重试',
  planReviewTitle: '计划审批',
  planRevisionSubmitted: '已提交修订请求，规划专家修订中…',
  revisePlan: '修订并重提',
  reviseTitle: '修订计划',
  confirmRevise: '提交修订',
  reviseNeedFeedback: '修订需要填写反馈，规划专家才知道改什么',
  terminateTask: '终止任务',
  terminateTaskWarning: '将终止本次任务并作废当前计划（checkpoints 清理）。反馈不会提交给专家。此操作不可恢复。',
  revisingTitle: '专家修订中',
  revisingHint: '反馈已提交，规划专家正在修订计划；完成后会重新提交审批，可继续裁决或关闭弹窗等待。',
  revisionFailed: '计划修订失败，原计划保持待审：可重试修订、直接批准或终止。',
  planRevisedToast: '专家已提交修订版 v{version}，请重新裁决',

  tasksPendingConfirm: '{count} 个任务待确认',
  planReviewViewBtn: '查看并审核',
  planReviewPaused: '任务在此暂停，直到你批准或驳回',
  approvalModalNote: '专家提交了以下执行计划。批准后任务将继续执行；驳回可附反馈，反馈会保留在会话中。',
  approveRun: '批准执行',
  feedbackNote: '你的反馈会作为你的消息保留在这个会话中',
  feedbackPlaceholder: '例如：第 3 步先不要动数据库列宽，刚修过…',
  feedbackHint: '驳回后任务将终止；重新发起任务时，专家可以参考你的反馈。',
  editPlan: '编辑计划',
  finishEdit: '完成',
  planVersionMeta: '计划 v{version}',
  planDiffShow: '本次修订改动 · {count} 处',
  planDiffHide: '收起改动',
  planDiffKindChanged: '改',
  planDiffKindAdded: '增',
  planDiffKindRemoved: '删',
  planDiffUnchanged: '其余 {count} 条未变',
  planDiffNoChanges: '本次修订没有改动任务内容。',
  planDiffNote: '按任务位置对照（修订会重建任务行，逐条的 id 会变）。',
  planStepExecutor: '{expert} 执行',
  planOutput_html: 'HTML',
  planOutput_code: '代码',
  planOutput_doc: '文档',
  toolSearchLabel: '检索可用工具',
  missingRunId: '缺少运行实例 ID，无法继续',
  cannotResume: '无法恢复执行',
  cannotSubmitRevision: '无法提交修订',
  cannotTerminate: '无法终止当前任务',
  backgroundTaskNotice: '检测到页面曾切换到后台，任务仍在执行中。请等待完成或刷新页面查看最新结果。',
  streamInterruptedNotice: '连接中断，但任务仍在后台执行；完成后本页会自动更新。',
  aiThinkingPlaceholder: '思考中…',
  aiGeneratingPlaceholder: '生成中…',
  imageLinkExpired: '图片链接已过期，请重新生成',
  linkExpired: '链接已过期，请重新生成',
  videoNotSupported: '您的浏览器不支持视频播放',
  thinkingPlanDone: '任务规划完成',
  thinkingTaskDone: '任务执行完成',
  thinkingToolCalling: '调用中…',
  expertStepLabel: '步骤 {index}/{total}',
  expertTaskFailed: '执行失败',
  expertArtifactPreview: '查看本步骤产出',
  expertPreviewAction: '预览',
  artifactLoadFailed: '产物加载失败，请稍后重试',
  expertExpandDesc: '展开完整描述',
  expertCollapseOutput: '收起',
  expertEarlierCalls: '早前 {count} 次调用',
  thinkingToolCalls: '次工具调用',
  thinkingToolRetrying: '重试中…',
  thinkingTaskFailed: '任务执行失败',
  thinkingRouterDone: '意图分析完成：已选择{mode}',
  activeRunConflictMsg: '当前会话已有进行中的任务，请先等待完成、确认恢复、取消任务，或切换到新会话后再继续。',
  canvasSearch: '搜索产物…',
  jumpToBottom: '回到底部',
  canvasAllTypes: '全部',
  canvasSearchEmpty: '没有匹配的产物',
  artifactTypeCode: '代码',
  artifactTypeSql: 'SQL',
  artifactTypeJson: 'JSON',
  artifactTypeChart: '图表',
  artifactTypeHtml: '网页',
  artifactTypeMarkdown: '文档',
  artifactTypeReport: '报告',
  artifactTypeSearch: '搜索',
  artifactTypeImage: '图片',
  artifactTypeVideo: '视频',
  artifactTypeMedia: '媒体',
  artifactTypeText: '文本',
  planApprovedMsg: '计划已批准，将由专家团队协作完成',
  planConflictMsg: '计划已被其他操作更新，请刷新后重新确认',
  resumeFailed: '启动失败，请检查网络后重试',
  planRejectedMsg: '计划已驳回，任务已终止',

  // —— 自 common.ts 按域迁入 ——
  copy: '复制',
  copied: '已复制',
  regenerate: '重新生成',
  retry: '重试',
}

export const en = {
  // Chat
  emptyTitle: 'Hand the task to your experts',
  emptySub: 'Describe your goal — collaboration, plan approval and artifacts live here',
  emptyCardTemplate: 'Start from template',
  emptyCardTemplateDesc: 'Kick off with a chat template',
  emptyCardExpert: 'New expert',
  emptyCardExpertDesc: 'Define a custom expert',
  emptyCardChat: 'Just start chatting',
  emptyCardChatDesc: 'Type your first message below',

  // Chat messages

  // Input & Chat
  uploadImage: 'Upload Image',
  attachmentImages: 'Images ×{count}',
  simple: 'Simple',
  complex: 'Complex',
  stop: 'Stop',
  send: 'Send',
  inputPlaceholder: 'Continue the conversation, or drop images…',

  // Expert Status
  clear: 'Clear',
  searchExpert: 'Search Expert',
  analyzerExpert: 'Analyzer Expert',
  imageAnalyzerExpert: 'Image Analysis Expert',
  memoryExpert: 'Memory Expert',
  designerExpert: 'Design Expert',
  architectExpert: 'Architecture Expert',
  aggregatorExpert: 'Synthesizer',
  commanderExpert: 'Orchestrator',
  routerExpert: 'Intent Router',
  pending: 'Pending',
  running: 'Running',
  completed: 'Completed',

  // Orchestrator Panel

  // Expert Modal

  // Artifact Area

  // Preview Button
  preview: 'Preview',
  source: 'Source',

  // Thinking Process
  thinking: 'Thinking',
  thinkingProcess: 'Thinking Process',
  thinkingSteps: 'Execution Steps',
  thinkingCompleted: 'Thinking Completed',
  thinkingInProgress: 'Thinking in Progress',
  thinkingGroupTasks: '{count} tasks',

  // Workflow Steps (Expert Drawer)

  // Thinking Steps
  thinkingSearch: 'Search',
  thinkingReading: 'Deep Reading',
  thinkingAnalysis: 'Analysis',
  thinkingCoding: 'Code Generation',
  thinkingPlanning: 'Task Planning',
  thinkingWriting: 'Writing',
  thinkingArtifact: 'Artifact Generation',
  thinkingMemory: 'Memory Retrieval',
  thinkingExecution: 'Task Execution',
  thinkingDefault: 'Thinking',
  thinkingRouting: 'Routing',
  thinkingReasoning: 'Deep Thinking',
  videoUnsupported: 'Your browser does not support video playback',

  // Preview Related
  videoPreview: 'Video Preview',
  imagePreview: 'Image Preview',
  messagePreview: 'Message Preview',
  docView: 'Document view',
  expandAll: 'Expand all',
  collapseAll: 'Collapse',

  // Other Messages
  minOneTask: 'At least one task must be kept',
  deleteTask: 'Delete Task',

  // Polling (Polling Recovery)
  pollingRestoring: 'Restoring task connection...',
  pollingHitlPaused: 'Waiting for approval...',
  pollingRefresh: 'Refresh',
  pollingError: 'Connection failed, please refresh',
  planReviewTitle: 'Plan Approval',
  planRevisionSubmitted: 'Revision submitted — the planner is revising…',
  revisePlan: 'Revise & resubmit',
  reviseTitle: 'Revise plan',
  confirmRevise: 'Submit revision',
  reviseNeedFeedback: 'A revision needs your feedback — the expert needs to know what to change',
  terminateTask: 'Terminate task',
  terminateTaskWarning: 'This terminates the run and discards the current plan (checkpoints cleaned). Feedback will NOT reach the expert. This cannot be undone.',
  revisingTitle: 'Expert revising',
  revisingHint: 'Feedback submitted — the planner is revising the plan. It will resubmit for approval; keep this open or close and wait.',
  revisionFailed: 'Plan revision failed. The original plan stays pending: retry revision, approve, or terminate.',
  planRevisedToast: 'Expert submitted revision v{version} — please review again',

  tasksPendingConfirm: '{count} tasks to confirm',
  planReviewViewBtn: 'Review plan',
  planReviewPaused: 'Task paused until you approve or reject',
  approvalModalNote: 'An expert submitted the plan below. Approving resumes execution; rejecting lets you attach feedback, which is kept in this conversation.',
  approveRun: 'Approve & run',
  feedbackNote: 'your feedback will be kept in this conversation as your message',
  feedbackPlaceholder: 'e.g. Leave the DB column width alone in step 3 — just fixed…',
  feedbackHint: 'Rejecting terminates the task; the expert can refer to your feedback in future runs.',
  editPlan: 'Edit plan',
  finishEdit: 'Done',
  planVersionMeta: 'Plan v{version}',
  planDiffShow: 'Changes in this revision · {count}',
  planDiffHide: 'Hide changes',
  planDiffKindChanged: 'EDIT',
  planDiffKindAdded: 'NEW',
  planDiffKindRemoved: 'DEL',
  planDiffUnchanged: '{count} other tasks unchanged',
  planDiffNoChanges: 'This revision changed no task content.',
  planDiffNote: 'Compared by task position (a revision rebuilds the task rows, so per-row ids change).',
  planStepExecutor: '{expert} executes',
  planOutput_html: 'HTML',
  planOutput_code: 'Code',
  planOutput_doc: 'Doc',
  toolSearchLabel: 'Search tools',
  missingRunId: 'Missing run ID — cannot continue',
  cannotResume: 'Cannot resume execution',
  cannotSubmitRevision: 'Cannot submit revision',
  cannotTerminate: 'Cannot terminate the current task',
  backgroundTaskNotice: 'The page was backgrounded but your task kept running. Wait for it to finish or refresh to see the latest result.',
  streamInterruptedNotice: 'Connection dropped, but the task is still running in the background — this page will update automatically when it finishes.',
  aiThinkingPlaceholder: 'Thinking…',
  aiGeneratingPlaceholder: 'Generating…',
  imageLinkExpired: 'Image link expired — please regenerate',
  linkExpired: 'Link expired — please regenerate',
  videoNotSupported: 'Your browser does not support video playback',
  thinkingPlanDone: 'Plan completed',
  thinkingTaskDone: 'Task completed',
  thinkingToolCalling: 'Calling…',
  expertStepLabel: 'Step {index}/{total}',
  expertTaskFailed: 'Failed',
  expertArtifactPreview: 'View step output',
  expertPreviewAction: 'Preview',
  artifactLoadFailed: 'Failed to load artifact, please retry later',
  expertExpandDesc: 'Expand full description',
  expertCollapseOutput: 'Collapse',
  expertEarlierCalls: '{count} earlier calls',
  thinkingToolCalls: 'tool calls',
  thinkingToolRetrying: 'Retrying…',
  thinkingTaskFailed: 'Task failed',
  thinkingRouterDone: 'Intent analysis complete — {mode} selected',
  activeRunConflictMsg: 'This conversation already has a task in progress. Wait for it to finish, approve/resume, cancel it, or start a new conversation.',
  canvasSearch: 'Search artifacts…',
  jumpToBottom: 'Jump to bottom',
  canvasAllTypes: 'All',
  canvasSearchEmpty: 'No matching artifacts',
  artifactTypeCode: 'Code',
  artifactTypeSql: 'SQL',
  artifactTypeJson: 'JSON',
  artifactTypeChart: 'Chart',
  artifactTypeHtml: 'Web page',
  artifactTypeMarkdown: 'Document',
  artifactTypeReport: 'Report',
  artifactTypeSearch: 'Search',
  artifactTypeImage: 'Image',
  artifactTypeVideo: 'Video',
  artifactTypeMedia: 'Media',
  artifactTypeText: 'Text',
  planApprovedMsg: 'Plan approved. The expert team will take it from here',
  planConflictMsg: 'The plan was updated elsewhere. Refresh and confirm again',
  resumeFailed: 'Failed to start, check your network and retry',
  planRejectedMsg: 'Plan rejected, task terminated',

  // —— 自 common.ts 按域迁入 ——
  copy: 'Copy',
  copied: 'Copied',
  regenerate: 'Regenerate',
  retry: 'Retry',
}

export const ja = {
  // Chat
  emptyTitle: 'タスクを専門家チームへ',
  emptySub: '目標を書くだけで、協業・計画承認・産物管理はここで完結',
  emptyCardTemplate: 'テンプレから開始',
  emptyCardTemplateDesc: 'チャットテンプレで即スタート',
  emptyCardExpert: '専門家を作成',
  emptyCardExpertDesc: '専属の協業専門家を定義',
  emptyCardChat: 'すぐ会話を始める',
  emptyCardChatDesc: '下の入力欄に最初の一言を',

  // Chat messages

  // Input & Chat
  uploadImage: '画像をアップロード',
  attachmentImages: '画像 ×{count}',
  simple: 'シンプル',
  complex: '複雑',
  stop: '停止',
  send: '送信',
  inputPlaceholder: '会話を続けるか、画像をドラッグ…',

  // Expert Status
  clear: 'クリア',
  searchExpert: '検索エキスパート',
  analyzerExpert: '分析エキスパート',
  imageAnalyzerExpert: '画像分析エキスパート',
  memoryExpert: 'メモリーエキスパート',
  designerExpert: 'デザインエキスパート',
  architectExpert: 'アーキテクチャエキスパート',
  aggregatorExpert: '統合エキスパート',
  commanderExpert: 'オーケストレーター',
  routerExpert: 'インテントルーター',
  pending: '待機中',
  running: '実行中',
  completed: '完了',

  // Orchestrator Panel

  // Expert Modal

  // Artifact Area

  // Preview Button
  preview: 'プレビュー',
  source: 'ソース',

  // Thinking Process
  thinking: '思考プロセス',
  thinkingProcess: '思考プロセス',
  thinkingSteps: '実行ステップ',
  thinkingCompleted: '思考完了',
  thinkingInProgress: '思考中',
  thinkingGroupTasks: '{count} 件のタスク',

  // Workflow Steps (Expert Drawer)

  // Thinking Steps
  thinkingSearch: '検索',
  thinkingReading: '深度読解',
  thinkingAnalysis: '分析思考',
  thinkingCoding: 'コード生成',
  thinkingPlanning: 'タスク計画',
  thinkingWriting: 'ライティング',
  thinkingArtifact: '成果物生成',
  thinkingMemory: '記憶検索',
  thinkingExecution: 'タスク実行',
  thinkingDefault: '思考',
  thinkingRouting: 'ルーティング',
  thinkingReasoning: '深い思考',
  videoUnsupported: 'お使いのブラウザは動画再生に対応していません',

  // プレビュー関連
  videoPreview: '動画プレビュー',
  imagePreview: '画像プレビュー',
  messagePreview: 'メッセージプレビュー',
  docView: 'ドキュメント表示',
  expandAll: '全文を表示',
  collapseAll: '折りたたむ',

  // その他メッセージ
  minOneTask: '最低1つのタスクを保持する必要があります',
  deleteTask: 'タスクを削除',

  // Polling (ポーリング復旧)
  pollingRestoring: 'タスク接続を復元中...',
  pollingHitlPaused: '承認待ち...',
  pollingRefresh: '更新',
  pollingError: '接続失敗、更新してください',
  planReviewTitle: 'プラン承認',
  planRevisionSubmitted: '修正リクエストを送信しました。プランナーが修正中…',
  revisePlan: '修正して再提出',
  reviseTitle: 'プランを修正',
  confirmRevise: '修正を提出',
  reviseNeedFeedback: '修正にはフィードバックが必要です。専門家が何を変えるべきか知る必要があります',
  terminateTask: 'タスクを終了',
  terminateTaskWarning: 'この実行を終了し、現在のプランを破棄します（チェックポイント削除）。フィードバックは専門家に届きません。取り消せません。',
  revisingTitle: '専門家が修正中',
  revisingHint: 'フィードバックを送信しました。プランナーが修正中です。完了後に再提出されます。待機するか閉じてお待ちください。',
  revisionFailed: 'プランの修正に失敗しました。元のプランは承認待ちのままです：再試行、承認、または終了できます。',
  planRevisedToast: '専門家が修正版 v{version} を提出しました。再審査してください',

  tasksPendingConfirm: '{count}件のタスクが確認待ち',
  planReviewViewBtn: 'プランを審査',
  planReviewPaused: '承認または却下するまでタスクは一時停止中',
  approvalModalNote: '専門家が以下の実行プランを提出しました。承認すると実行が再開されます。却下する場合はフィードバックを添えられます（会話に残ります）。',
  approveRun: '承認して実行',
  feedbackNote: 'フィードバックはあなたのメッセージとしてこの会話に残ります',
  feedbackPlaceholder: '例：ステップ3でDBカラム幅は変更しないで…',
  feedbackHint: '却下するとタスクは終了します。次回実行時に専門家がフィードバックを参照できます。',
  editPlan: 'プランを編集',
  finishEdit: '完了',
  planVersionMeta: 'プラン v{version}',
  planDiffShow: '今回の修正点 · {count} 件',
  planDiffHide: '修正点を閉じる',
  planDiffKindChanged: '変',
  planDiffKindAdded: '追',
  planDiffKindRemoved: '削',
  planDiffUnchanged: '他 {count} 件は変更なし',
  planDiffNoChanges: '今回の修正でタスク内容の変更はありません。',
  planDiffNote: 'タスクの位置で比較しています（修正はタスク行を作り直すため、行ごとの id は変わります）。',
  planStepExecutor: '{expert} が実行',
  planOutput_html: 'HTML',
  planOutput_code: 'コード',
  planOutput_doc: '文書',
  toolSearchLabel: 'ツール検索',
  missingRunId: '実行IDが見つからないため続行できません',
  cannotResume: '実行を再開できません',
  cannotSubmitRevision: '修正を提出できません',
  cannotTerminate: '現在のタスクを終了できません',
  backgroundTaskNotice: 'ページがバックグラウンドに切り替わっていましたが、タスクは実行中です。完了を待つか、更新して最新の結果をご確認ください。',
  streamInterruptedNotice: '接続が切断されましたが、タスクはバックグラウンドで実行中です。完了するとこのページは自動的に更新されます。',
  aiThinkingPlaceholder: '思考中…',
  aiGeneratingPlaceholder: '生成中…',
  imageLinkExpired: '画像リンクの有効期限が切れました。再生成してください',
  linkExpired: 'リンクの有効期限が切れました。再生成してください',
  videoNotSupported: 'お使いのブラウザは動画再生に対応していません',
  thinkingPlanDone: 'タスク計画が完了しました',
  thinkingTaskDone: 'タスク実行が完了しました',
  thinkingToolCalling: '呼び出し中…',
  expertStepLabel: 'ステップ {index}/{total}',
  expertTaskFailed: '実行失敗',
  expertArtifactPreview: 'このステップの成果物を見る',
  expertPreviewAction: 'プレビュー',
  artifactLoadFailed: '成果物の読み込みに失敗しました',
  expertExpandDesc: '説明全文を展開',
  expertCollapseOutput: '折りたたむ',
  expertEarlierCalls: '以前の {count} 回の呼び出し',
  thinkingToolCalls: '回のツール呼び出し',
  thinkingToolRetrying: 'リトライ中…',
  thinkingTaskFailed: 'タスクの実行に失敗しました',
  thinkingRouterDone: '意図分析が完了しました：{mode} を選択',
  activeRunConflictMsg: 'この会話には実行中のタスクがあります。完了を待つか、承認・再開・キャンセルするか、新しい会話で続行してください。',
  canvasSearch: '成果物を検索…',
  jumpToBottom: '一番下へ',
  canvasAllTypes: 'すべて',
  canvasSearchEmpty: '一致する成果物がありません',
  artifactTypeCode: 'コード',
  artifactTypeSql: 'SQL',
  artifactTypeJson: 'JSON',
  artifactTypeChart: 'チャート',
  artifactTypeHtml: 'ウェブページ',
  artifactTypeMarkdown: 'ドキュメント',
  artifactTypeReport: 'レポート',
  artifactTypeSearch: '検索',
  artifactTypeImage: '画像',
  artifactTypeVideo: '動画',
  artifactTypeMedia: 'メディア',
  artifactTypeText: 'テキスト',
  planApprovedMsg: 'プラン承認済み。専門家チームが連携して進めます',
  planConflictMsg: 'プランは他の操作で更新されました。更新してから再度確認してください',
  resumeFailed: '開始に失敗しました。ネットワークを確認して再試行してください',
  planRejectedMsg: 'プランは却下され、タスクは終了しました',

  // —— 自 common.ts 按域迁入 ——
  copy: 'コピー',
  copied: 'コピー済み',
  regenerate: '再生成',
  retry: '再試行',
}
